import { MAX_BID_AMOUNT } from '~/config/constants';
import { Member } from '~/App/shared/interfaces/Member';
import Auction from '~/App/shared/interfaces/Auction';

export const isBelowMaxBid = (bidAmount: string) => {
  return !bidAmount || parseInt(bidAmount, 10) <= MAX_BID_AMOUNT;
};

export const isValidBidIncrement = (
  bidAmount: number,
  increment: number
): boolean => {
  return bidAmount % increment === 0;
};

export const getBiddingFeeForMember = (member: Member, auction: Auction) => {
  const biddingFee =
    member.memberType === 'ORGANISATION_PERSON'
      ? auction.biddingFeeCorporate
      : auction.biddingFee;

  return parseInt(biddingFee, 10);
};
